import { Red500 } from '@zep-us/zus/tokens';
import { type YoutubeVideoData } from '@/api/ai/youtube/types';
import { YoutubeFillIcon } from '@/icons';
import { Chip } from '@/ui_v3';
export const YoutubeThumbnail = ({
  videoData,
  onClick
}: {
  videoData: YoutubeVideoData;
  onClick: () => void;
}) => {
  return <div role="button" className="relative flex h-full w-full cursor-pointer items-center justify-center" onClick={onClick} aria-label="Play video" data-sentry-component="YoutubeThumbnail" data-sentry-source-file="YoutubeThumbnail.tsx">
      <img src={videoData.thumbnailUrl} alt={videoData.title} className="h-full w-full object-cover" />

      <YoutubeFillIcon className="absolute flex size-[100px] items-center justify-center" fill={Red500} data-sentry-element="YoutubeFillIcon" data-sentry-source-file="YoutubeThumbnail.tsx" />

      <Chip className="absolute bottom-[10px] right-sm rounded-sm border border-opacity-white-3 bg-opacity-black-8 px-2xs text-caption-md-semibold text-inverse" size="sm" data-sentry-element="Chip" data-sentry-source-file="YoutubeThumbnail.tsx">
        {formatDuration(videoData.durationSeconds)}
      </Chip>
    </div>;
};

/**
 * 영상 길이 포맷팅 (초 → MM:SS 또는 H:MM:SS)
 * - 1시간 이상: H:MM:SS
 * - 1시간 미만: MM:SS
 */
const formatDuration = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor(seconds % 3600 / 60);
  const secs = seconds % 60;
  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  }
  return `${minutes}:${String(secs).padStart(2, '0')}`;
};